import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Button, Card, CardBody } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";

const ClientCommercialDocuments = ({ t }) => {
  document.title = t(
    "clientCommercialDocumentsPageTitle",
    "Commercial Documents | Client"
  );

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={t(
            "clientMenuCommercialDocuments",
            "Commercial Documents"
          )}
          breadcrumbItem={t(
            "clientMenuCommercialDocuments",
            "Commercial Documents"
          )}
        />

        <Card className="client-coming-soon border-0">
          <CardBody className="p-4 p-lg-5 text-center">
            <div className="client-coming-soon__icon mb-3" aria-hidden="true">
              <i className="bx bx-file" />
            </div>
            <div className="client-coming-soon__eyebrow mb-2">
              {t("clientComingSoonEyebrow", "Coming soon")}
            </div>
            <h2 className="client-coming-soon__title mb-3">
              {t(
                "clientCommercialDocumentsTitle",
                "Commercial documents are on the way"
              )}
            </h2>
            <p className="client-coming-soon__copy mx-auto mb-4">
              {t(
                "clientCommercialDocumentsCopy",
                "We’re building a central place for agreements, invoices, purchase orders, and other commercial paperwork. In the meantime, you can manage bookings from your dashboard or contact JobArk for support."
              )}
            </p>
            <div className="d-flex flex-wrap justify-content-center gap-2">
              <Button tag={Link} to="/dashboard" color="primary">
                {t("clientMenuDashboard", "Dashboard")}
              </Button>
              <Button tag={Link} to="/contact-us" color="secondary" outline>
                {t("clientMenuContactJobark", "Contact JobArk")}
              </Button>
            </div>
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default withTranslation()(ClientCommercialDocuments);
